import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import cartService from "../../Service/cart.service";
import AccountPageHeader from "./components/AccountPageHeader";
import { useSearchParams } from "react-router-dom";
import SubscriptionHistory from "./components/SubscriptionHistory/SubscriptionHistory";
import SubscriptionDetails from "./components/SubscriptionDetails/SubscriptionDetails";
import "./index.scss";

const Accounts: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabKey, setActiveTabKey] = useState(
    searchParams.get("tab") || "subscription",
  );

  const tabList = [
    // {
    //   key: "details",
    //   label: "Details",
    // },
    {
      key: "subscription",
      label: "Subscription & Usage",
    },
    {
      key: "invoices",
      label: "Invoices",
    },
  ];

  const handleTabChange = (key: string) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("tab", key);
      return newParams;
    });
    setActiveTabKey(key);
  };

  useEffect(() => {
    cartService.clearCart();
  }, []);

  const getTabChildren = (tab: string) => {
    // if (tab === "details") {
    //   return (
    //     <Details />
    //   );
    // }
    if (tab === "invoices") {
      return <SubscriptionHistory />;
    } else if (tab === "subscription") {
      return <SubscriptionDetails />;
    }
  };

  return (
    <section className="accounts-page">
      <AccountPageHeader />
      <Tabs
        style={{ margin: "0px", width: "100%" }}
        activeKey={activeTabKey}
        items={tabList}
        onChange={handleTabChange}
        size="small"
      />
      <div className="job-post-details-tab-children-wrapper">
        {getTabChildren(activeTabKey)}
      </div>
    </section>
  );
};

export default Accounts;
